<template>
  <div class="profit">
    <progressBar
      class="profit-progress"
      :arr="progressData"
      :activeIndex="progressActiveIndex"></progressBar>
    <tips class="profit-tip">
      <div class="profit-tip__line"> 1. 用户需先“新建在售商品利润核算信息”，在系统设定的每月月底及时“上传汇总数据报告”后，系统将自动进行准确的在售商品利润核算; </div>
      <div class="profit-tip__line"> 2. 当“上传汇总报告”后，发现下面列表内出现"无对应数据"的Listing信息时，说明该Listing之前忘记创建了；可点击“补充创建”，在弹窗中选择对应Listing信息进行补充创建； </div>
      <div class="profit-tip__line"> 3. 上期月结数据汇总日期： 2025-10-01 ~ 下期月结数据汇总日期： 2025-10-31</div>
    </tips>
    <div class="profit-top">
      <div class="profit-top__title">在售商品与店铺利润核算</div>
      <div class="profit-top__right">
        <div class="profit-top-item profit-top-item--long">
          <div class="profit-top-item__name">汇总日期:</div>
          <el-select v-model="searchData.store" size="mini"></el-select>
        </div>
        <div class="profit-top-item">
          <div class="profit-top-item__name">店铺:</div>
          <el-select v-model="searchData.store" size="mini"></el-select>
        </div>
        <div class="profit-top-item">
          <div class="profit-top-item__name">国家站点:</div>
          <el-select v-model="searchData.countrySite" size="mini"></el-select>
        </div>
        <div class="profit-top-item profit-top-item--long">
          <el-input v-model="searchData.text" size="mini" placeholder="请输入产品型号/名称/ASIN"></el-input>
        </div>
        <div class="profit-top__btn">搜索</div>
        <!-- <div class="profit-top__btn">新建在售商品利润核算</div> -->
        <div class="profit-top__btn">查看更多信息</div>
        <div class="profit-top__btn profit-top__btn--orange">上传汇总报告</div>
        <div class="profit-top__btn profit-top__btn--orange">补充创建</div>
      </div>
    </div>
    <div class="profti-table">
      <Table
        :head="profitTableHead"
        :body="profitList"
        width="1654"
        height="550"></Table>
    </div>
  </div>
</template>

<script>
import { ProfitSearchData, ProductProfitNewModule } from './class'
import progressBar from 'components/common/progressBar';
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
import UserAxios from 'service/user'
export default {
  name: 'productProfit',
  components: {
    progressBar, tips, Table
  },
  data(){
    return {
      /**进度条数据 */
      progressData: ProductProfitNewModule.NEWPROGRESSARRAY(),
      progressActiveIndex: 6,
      /**搜索数据 */
      searchData: new ProfitSearchData(),
      /**表头 */
      profitTableHead: ProductProfitNewModule.NEWTABLEHEAD(),
      profitList: [],
      /**汇总日期数组 */
      summaryDataArray: []
    }
  },
  methods: {
    /**导入数据 */
    importData(array){
      let startTime, endTime
      return array.map((object, index) => {
        endTime = new Date(object).Format('yyyy-MM-dd')
        if(index === 0){
          startTime = new Date(array[array.length - 1] + 24*60*60*1000).Format('yyyy-MM-dd')
        }else{
          startTime = new Date(array[index - 1] + 24*60*60*1000).Format('yyyy-MM-dd')
        }
        return startTime + ' - ' + endTime
      })
    },
    /**获取已设置的汇总日期 */
    async getSetSummaryTime(){
      let res = await UserAxios.getSummaryDate()
      if(res.data.code !== 1){
        this.$message.error(res.data.info)
        return;
      }
      let data = res.data.info
      this.summaryDataArray = this.importData(data)
      console.log(this.summaryDataArray);
    },
  },
  created(){
    this.getSetSummaryTime()
  },
}
</script>

<style lang="scss" scoped>
.profit{
  width: 1800px;
  &-progress{
    margin-bottom: 5px;
  }
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__title{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__right{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 120px;
        }
      }
      &__name{
        font-size: 14px;
      }
      &--long{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
    }
    &__btn{
      min-width: 80px;
      text-align: center;
      margin-left: 10px;
      padding: 0 15px;
      height: 30px;
      line-height: 30px;
      color: white;
      background: #00a0c7;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
      &--orange{
        background: #fca605;
      }
    }
  }
}
</style>
